import React, { useState } from "react";

interface IExpandableText {
  text: string;
  maxLength?: number;
}

const ExpandableText: React.FC<IExpandableText> = ({ text, maxLength = 100 }) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return null;

  const isLong = text.length > maxLength;
  const displayText = expanded || !isLong ? text : text.slice(0, maxLength) + "...";

  return (
    <span>
      {displayText}{" "}
      {isLong && (
        <button
          style={{
            background: "none",
            border: "none",
            color: "#FF8C42",
            cursor: "pointer",
            padding: 0,
          }}
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show Less" : "Show More"}
        </button>
      )}
    </span>
  );
};

export default ExpandableText;
